import { Link } from "react-router-dom";

const CoursesCard = ({ data, isEnrolled, tab, onPaymentClick }: any) => {
  const getAvgReview = (reviews: any) => {
    const sum = reviews.reduce((a: any, b: any) => a + b.rating, 0);
    const avg = sum / reviews.length;

    return avg ? Number(avg).toFixed(1) : 0.0;
  };
  return (
    <>
      {/* <div className="swiper-slide"> */}
      <div className="col">
        <div
          className="courses__item shine__animate-item"
          style={{ padding: "25px 25px 10px", minHeight: "500px" }}
        >
          <div className="courses__item-thumb">
            <Link
              to={`/creative-warriors-course-detail/${data?.id}`}
              className="shine__animate-link"
            >
              <img
                src={data?.featuredImage || "/assets/img/cw/1.png"}
                alt="img"
              />
            </Link>
          </div>
          <div className="courses__item-content">
            <ul className="courses__item-meta list-wrap">
              <Link to={`/creative-warriors-course-detail/${data?.id}`}>
                {/* {(data?.category &&
                    data?.category?.length > 0 &&
                    data?.category[0]) ||
                  tab?.tab === "vidyadaan"
                    ? "Vidyadaan"
                    : "Creative Warriors"} */}
                {data?.courseAuthorRole}
              </Link>
              {data?.reviews?.reviews && (
                <div className="avg-rating">
                  <i className="fas fa-star"></i> (
                  {getAvgReview(data?.reviews?.reviews)} Reviews)
                </div>
              )}
            </ul>
            <h5 className="title">
              <Link to={`/creative-warriors-course-detail/${data?.id}`}>
                {data?.title}
              </Link>
            </h5>

            {tab?.tab !== "vidyadaan" && (
              <>
                <p className="author">By {data?.authorName}</p>
                <div className="courses__item-bottom">
                  {isEnrolled ? (
                    <div className="button disabled">
                      <button className="link-button enrolled">
                        <span className="text">Enrolled</span>
                        {/* <i className="flaticon-arrow-right"></i> */}
                      </button>
                    </div>
                  ) : (
                    <div
                      className="button"
                      onClick={() => onPaymentClick(data)}
                    >
                      <button className="link-button">
                        <span className="text">Enroll Now</span>
                        <i className="flaticon-arrow-right"></i>
                      </button>
                    </div>
                  )}

                  <div className="price">
                    <span>₹</span>
                    {data?.coursePrice?.regularPrice || 499}
                  </div>
                </div>
                <div
                  className="courses__item-bottom-two"
                  style={{ padding: "10px 5px", marginTop: "25px" }}
                >
                  <ul className="list-wrap">
                    <li>
                      <i className="flaticon-book"></i>
                      {data?.courseDuration}
                    </li>
                    <li>
                      <i className="flaticon-mortarboard"></i>
                      {data?.lessonsCount}
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default CoursesCard;
